/* Lightweight client-side logger.
 * Silent in production to avoid leaking debug information into the console;
 * forwards to the console only during development. Swap the dev branch for a
 * real logging/monitoring service (e.g. Sentry) when one is introduced. */
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (isDev) console.error(...args);
};

export const logInfo = (...args) => {
  if (isDev) console.info(...args);
};

export default { logError, logInfo };
